<i class="sch-info-circle sdps-text-active tooltip-icon" (click)="tooltip.toggle()">
    <i #tooltip="matTooltip"
      [matTooltip]=infoMessage
      matTooltipPosition="right"
      matTooltipClass="info-message-tooltip">
    </i>
</i>
